import React from "react";
import { Dialog } from "@/components/ui/organisms/Dialog";
import { Button } from "@/components/ui/atoms/Button";
import { Typography } from "@/components/ui/atoms/Typography";

interface SendInvitationConfirmationDialogProps {
  open: boolean;
  email: string;
  isPending?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const SendInvitationConfirmationDialog: React.FC<SendInvitationConfirmationDialogProps> = ({
  open,
  email,
  isPending = false,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
      title="Confirm Send Invitation"
      backdropZIndex={200}
    >
      <Dialog.Header titleVariant="h3" title="Confirm Send Invitation" showCloseButton />
      <Dialog.Body className="space-y-4">
        <div className="space-y-2">
          <Typography variant="body-sm" color="secondary" weight="medium" as="p">
            Are you sure you want to send this invitation?
          </Typography>
          <Typography variant="body-sm" color="secondary" weight="medium" as="p">
            You are about to send an invitation to{" "}
            <Typography as="span" variant="body-sm" color="primary" weight="semibold">
              {email}
            </Typography>
            .
          </Typography>
        </div>
      </Dialog.Body>
      <Dialog.Footer align="right">
        <Button
          type="outlined"
          intent="secondary"
          onClick={onClose}
          disabled={isPending}
          label="Cancel"
        />
        <Button
          type="contained"
          intent="secondary"
          onClick={onConfirm}
          disabled={isPending || !email.trim()}
          loading={isPending}
          label={isPending ? "Sending..." : "Confirm"}
        />
      </Dialog.Footer>
    </Dialog>
  );
};
